module.exports = __webpack_public_path__ + "img/logo-gradient.0fd6a7be.svg";